<template>
<section class="pr-section _edit-section">
    <div class="section-inner">

        <div class="item form_text">
            <textarea name="pr" id="pr1" maxlength="250" placeholder=" "  v-model="top_news"></textarea>
            <label for="pr1" class="m-label"><span>トップニュース</span></label>
        </div>

    </div>
</section>
</template>

<script>

    export default {
        data() {
            return {
                top_news: '',
            };
        },
        watch: {
            top_news: function (value) {
                this.$store.state.register.form.top_news = value;
            },
        },
        created() {
            // 編集の場合
            if (this.$store.state.detail.set.brand.top_news) {
                this.top_news = this.$store.state.detail.set.brand.top_news;
                this.$store.state.register.form.top_news = this.$store.state.detail.set.brand.top_news;
            }
        },

    }
</script>
